import { entitlementsApi } from '../../services/entitlementsApi';

const getIsFlexUser = () => dispatch => dispatch(entitlementsApi.endpoints.getIsFlexUser.initiate());

export default getIsFlexUser;
